<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">
        {{ (mode == 'new' ? 'Langsamfahrstelle anlegen' : 'Langsamfahrstelle bearbeiten') | mrTranslate }}
      </span>
    </div>
    <div class="header-actions">
      @if (mode == 'edit') {
        <a
          href="javascript:void(0);"
          class="nav-link nav-icon tooltip tooltip-md tooltip-bottom-left"
          role="tooltip"
          aria-haspopup="true"
          (click)="switchMode('new')">
          <cds-icon shape="plus-circle" size="30" />
          <span class="tooltip-content">{{ 'Neue Langsamfahrstelle anlegen' | mrTranslate }}</span>
        </a>
      }

      <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times" />
      </a>
    </div>
  </header>

  <!-- <div id="lastelleWrapper"> -->
  <form
    class="login"
    id="lastelleform"
    clrForm
    [formGroup]="lastelleGroup"
    (ngSubmit)="onSubmit()"
    style="margin-left: 20px; margin-right: 15px">
    <div class="clr-row" style="margin-top: -20px">
      <div class="clr-col-md-6 clr-col-12 nopaddingleft">
        <clr-date-container>
          <label class="clr-col-md-4">{{ 'Beginn der Langsamfahrstelle' | mrTranslate }}</label>
          <input
            class="clr-col-md-8"
            type="date"
            name="date"
            clrDate
            [disabled]="mode === 'edit'"
            [ngModel]="lastelleGroup.controls.date.value | localeDate"
            (ngModelChange)="lastelleGroup.controls.date.setValue(localeDate.tosql($event))"
            [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
        </clr-date-container>
        <clr-input-container>
          <label class="clr-col-md-4">{{ 'Zeit Beginn' | mrTranslate }}</label>
          <input class="clr-col-md-8" clrInput placeholder="00:00" type="time" name="time" formControlName="time" />
        </clr-input-container>
        @if (mode == 'edit') {
          <clr-date-container>
            <label class="clr-col-md-4">{{ 'Ende der Langsamfahrstelle' | mrTranslate }}</label>
            <input
              class="clr-col-md-8"
              type="date"
              name="edate"
              clrDate
              [ngModel]="lastelleGroup.controls.edate.value | localeDate"
              (ngModelChange)="lastelleGroup.controls.edate.setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              [disabled]="lastelleGroup.disabled" />
          </clr-date-container>
          <clr-input-container>
            <label class="clr-col-md-4">{{ 'Zeit Ende' | mrTranslate }}</label>
            <input class="clr-col-md-8" clrInput placeholder="00:00" type="time" name="etime" formControlName="etime" />
          </clr-input-container>
        }

        <div class="comboboxcontainer clr-form-control clr-row">
          <label class="clr-col-md-4 clr-control-label">{{ 'gemeldet durch' | mrTranslate }}</label>
          <div class="clr-control-container clr-col-md-8">
            <input
              class="clr-input combobox"
              [placeholder]="'Name' | mrTranslate"
              type="search"
              name="gemeldetDurch"
              formControlName="gemeldetDurch"
              list="gemeldetDurchList" />
          </div>
          <datalist id="gemeldetDurchList">
            @if (gemeldetDurch) {
              @for (name of gemeldetDurch; track name) {
                <option [value]="name"></option>
              }
            }
          </datalist>
        </div>

        @if (mode == 'edit') {
          <div class="comboboxcontainer clr-form-control clr-row">
            <label class="clr-col-md-4 clr-control-label">{{ 'aufgehoben durch' | mrTranslate }}</label>
            <div class="clr-control-container clr-col-md-8">
              <input
                class="clr-input combobox"
                [placeholder]="'Name' | mrTranslate"
                type="search"
                name="aufgehobenDurch"
                formControlName="aufgehobenDurch"
                list="aufgehobenDurchList" />
            </div>
            <datalist id="aufgehobenDurchList">
              @if (aufgehobenDurch) {
                @for (name of aufgehobenDurch; track name) {
                  <option [value]="name"></option>
                }
              }
            </datalist>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'line') {
          <div id="lineWrapper">
            <div class="clr-row">
              <div class="clr-col">
                <clr-checkbox-wrapper class="clr-row">
                  <input type="checkbox" clrCheckbox name="gesamtesGleis" formControlName="gl_g" />
                  <label>{{ 'Gesamtes Gleis' | mrTranslate }}</label>
                </clr-checkbox-wrapper>
                @if (lastelleGroup.errors?.['not-in-Direction']; as err) {
                  <div class="clr-row nxm clr-col-auto">
                    <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                      <clr-alert-item>
                        <span class="alert-text">
                          {{
                            'Der Startmeter muss ' + (err.upwards ? 'kleiner' : 'größer') + ' als der Endmeter sein'
                              | mrTranslate
                          }}
                        </span>
                      </clr-alert-item>
                    </clr-alert>
                  </div>
                }
                <div class="clr-row width100 clr-align-items-start" [hidden]="lastelleGroup.value.gl_g">
                  <clr-number-input-container class="clr-col-6" clrInline>
                    <label class="clr-col-md-4">{{ 'von' | mrUnitText }}</label>
                    <input
                      type="number"
                      class=""
                      clrNumberInput
                      [placeholder]="startmeter !== undefined ? startmeter + '...' : '0'"
                      name="gleisVon"
                      formControlName="gl_v" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                    @if (lastelleGroup.controls.gl_v.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}
                      </clr-control-error>
                    }
                    @if (lastelleGroup.controls.gl_v.errors?.max; as err) {
                      <clr-control-error>{{ 'Der Wert ist größer als' | mrTranslate }} {{ err.max }}</clr-control-error>
                    }
                  </clr-number-input-container>
                  <clr-number-input-container class="clr-col-6" clrInline>
                    <label class="clr-col-md-4">{{ 'bis' | mrUnitText }}</label>
                    <input
                      type="number"
                      class=""
                      clrNumberInput
                      [placeholder]="endmeter !== undefined ? '...' + endmeter : '987'"
                      name="gleisBis"
                      formControlName="gl_b" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                    @if (lastelleGroup.controls.gl_b.errors?.min; as err) {
                      <clr-control-error>
                        {{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}
                      </clr-control-error>
                    }
                    @if (lastelleGroup.controls.gl_b.errors?.max; as err) {
                      <clr-control-error>{{ 'Der Wert ist größer als' | mrTranslate }} {{ err.max }}</clr-control-error>
                    }
                  </clr-number-input-container>
                </div>
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 1) {
          <div id="pointWrapper">
            <div class="clr-row">
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('2')"
                [ngClass]="{ active: lastelleGroup.value.ew == 2 }">
                <img class="vector" src="assets/icons/weichen/EW_blockStraight.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="2" formControlName="ew" />
                  <label class="radiolabel">{{ 'Gerade' | mrTranslate }}</label>
                </div>
              </div>
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('3')"
                [ngClass]="{ active: lastelleGroup.value.ew == 3 }">
                <img class="vector" src="assets/icons/weichen/EW_blockBranch.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="3" formControlName="ew" />
                  <label class="radiolabel">{{ 'Abzweig' | mrTranslate }}</label>
                </div>
              </div>
              <div
                class="clr-col blockPoint cursor-pointer"
                (click)="selectRadio('1')"
                [ngClass]="{ active: lastelleGroup.value.ew == 1 }">
                <img class="vector" src="assets/icons/weichen/EW_blockBoth.svg" />
                <div class="radio">
                  <input type="radio" clrRadio name="ew" value="1" formControlName="ew" />
                  <label class="radiolabel">{{ 'Gerade und Abzweig' | mrTranslate }}</label>
                </div>
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 2) {
          <div id="pointDoubleWrapper">
            <div class="clr-row">
              <div class="clr-col padding-20-lr">
                <strong>A</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="a" formControlName="dw_a" />
              </div>
              <div class="clr-col">
                <strong>B</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="b" formControlName="dw_b" />
              </div>
              <div class="clr-col">
                <strong>C</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="c" formControlName="dw_c" />
              </div>
            </div>
            <div class="clr-row">
              <div class="clr-col">
                <img class="vector mw-50p" src="assets/icons/weichen/DW1.svg" />
              </div>
              <div class="clr-col">
                <img class="vector mw-50p" src="assets/icons/weichen/DW2.svg" />
              </div>
            </div>
          </div>
        }

        @if ((typ_Line_Point | objtype) == 'point' && pointtype && pointtype == 3) {
          <div id="pointCrossWrapper" class="clr-row">
            <div class="checkboxes clr-col">
              <div>
                <strong>A</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="a" formControlName="kr_a" />
              </div>
              <div>
                <strong>B</strong>
                &nbsp;&nbsp;
                <input type="checkbox" clrCheckbox name="b" formControlName="kr_b" />
              </div>
            </div>
            <img src="assets/icons/weichen/KR.svg" class="clr-col vector" />
            <div class="checkboxes right clr-col">
              <div>
                <input type="checkbox" clrCheckbox name="c" formControlName="kr_c" />
                &nbsp;
                <strong>C</strong>
              </div>
              <div>
                <input type="checkbox" clrCheckbox name="d" formControlName="kr_d" />
                &nbsp;
                <strong>D</strong>
              </div>
            </div>
          </div>
        }

        <div id="lasteForm">
          <div class="clr-row">
            <clr-checkbox-wrapper class="clr-col padding-no-l">
              <input type="checkbox" clrCheckbox name="gesperrt" formControlName="gesperrt" />
              <label>{{ 'LA-Stelle aktiv' | mrTranslate }}</label>
            </clr-checkbox-wrapper>

            <!-- <div class="comboboxcontainer clr-form-control clr-col margin-no-t padding-no-r">
                          <label class="clr-col-md-4 clr-control-label">{{'V-Max' | mrTranslate}}</label>
                          <div class="clr-control-container clr-col-md-8 padding-5-r">
                            <input class="clr-input combobox padding-no-r" placeholder="V-Max" type="search" name="vmax"
                              formControlName="vmax" list="vmaxList" />
                            </div>
                            <datalist id="vmaxList">
                              <ng-container *ngIf="vmax">
                                <option *ngFor="let name of vmax" [value]="name">
                                </ng-container>
                              </datalist>
                            </div> -->

            <clr-select-container>
              <label class="clr-col-md-4 clr-control-label clr-required-mark">{{ 'V-Max' | mrTranslate }}</label>
              <select
                clrSelect
                name="options"
                formControlName="vmax"
                class="clr-col-md-8 padding-5-r"
                style="min-width: 100px"
                [disabled]="mode !== 'edit'">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="35">35</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
                <option value="70">70</option>
                <option value="80">80</option>
                <option value="90">90</option>
                <option value="100">100</option>
                <option value="110">110</option>
                <option value="120">120</option>
              </select>
            </clr-select-container>
          </div>

          <clr-textarea-container class="clr-row">
            <label class="clr-col-md-4">{{ 'Grund' | mrTranslate }}</label>
            <textarea class="clr-col-md-8 padding-no-r" clrTextarea name="grund" formControlName="grund"></textarea>
          </clr-textarea-container>
          <div class="clr-row">
            <button class="btn btn-primary" [disabled]="trial" type="submit">
              {{ (mode == 'new' ? 'Langsamfahrstelle anlegen' : 'Langsamfahrstelle bearbeiten') | mrTranslate }}
            </button>
          </div>
        </div>
      </div>
      <div id="history" class="clr-col-md-6 clr-col-12 nopaddingright">
        <br />
        <h3>{{ 'Historie' | mrTranslate }}</h3>
        <div class="limit-height">
          @if (history && history.columns) {
            <clr-datagrid class="datagrid-compact" #historyDatagrid>
              @for (column of history.columns; track column) {
                <clr-dg-column [clrDgField]="column.id">
                  <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: { show: ['richtung'] } }">
                    {{ column.id | mrTranslate | titlecase }}
                  </ng-container>
                </clr-dg-column>
              }
              <clr-dg-row
                *clrDgItems="let row of history.rows"
                [ngClass]="{ selectedrow: row.id == editId }"
                [clrDgItem]="row"
                [clrDgDetailHidden]="row.hasmangel === false">
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="editRow(row)">{{ 'Bearbeiten' | mrTranslate }}</button>
                  <button type="button" class="action-item" (click)="emailLA(row)">{{ 'Email' | mrTranslate }}</button>
                </clr-dg-action-overflow>
                @for (cell of history.columns; track cell) {
                  @if (cell.id != 'vmax' && cell.id != 'richtung') {
                    <clr-dg-cell><app-dg-cell [data]="row[cell.id]" [col]="cell.id" /></clr-dg-cell>
                  } @else {
                    <clr-dg-cell [title]="row[cell.id]">
                      @if (row.vmax | in: LA_VMAX) {
                        @let shape =
                          cell.id == 'richtung' ?
                            pointtype ? `richtung${row.richtung}`
                            : 'blank'
                          : `lastelle${row.vmax / 10}`.replace('.', '_');
                        <cds-icon class="grid-icon fill-black" [shape]="shape" size="32" />
                      } @else {
                        {{ row.vmax }}
                      }
                    </clr-dg-cell>
                  }
                }
              </clr-dg-row>
              <ng-template clrIfDetail let-detail (clrIfDetailChange)="onDetailOpen($event)">
                <clr-dg-detail>
                  <clr-dg-detail-header>{{ 'Mangel' | mrTranslate }}</clr-dg-detail-header>
                  <clr-dg-detail-body>
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="text-align: left">{{ 'Objekt' | mrTranslate }}</th>
                          <th style="text-align: left">{{ 'Bezeichnung' | mrTranslate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of firstRowKeyValues; track item) {
                          <tr>
                            <td style="text-align: left">{{ item.key | titlecase }}</td>
                            <td style="text-align: left">{{ item.value | tablePrettyPrint }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </clr-dg-detail-body>
                </clr-dg-detail>
              </ng-template>
              <clr-dg-footer>{{ 1 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          }
        </div>
      </div>
    </div>
  </form>
</div>

<!-- </div> -->
